import React, { FC, useCallback, useState } from 'react'

import { addCompanyManagerToCompany, addOtherRoles } from 'state/async_actions'
import { AutocompleteableItem } from 'types'
import { AddUserDropdown } from 'components/AddUserDropdown'
import { useAppContext } from 'state/context'
import { useCompanyManagers, useOtherRoles } from 'hooks/useCompanyManagers'

interface AddCompanyManagerDropdownProps {
  companyId?: number | undefined
  projectId?: number | undefined
  templateDocumentId?: number | undefined
  excludedCompanyManagers?: any
  isOtherRole?: boolean
  roleType?: string | undefined
  url?: string | undefined
}

export const AddCompanyManagerDropdown: FC<AddCompanyManagerDropdownProps> = ({
  companyId,
  projectId,
  templateDocumentId,
  excludedCompanyManagers,
  isOtherRole,
  roleType,
  url
}) => {
  const [, dispatch] = useAppContext()
  const [selectedFolder, setSelectedFolder] = useState([]);

  const addCompanyManager: (item: AutocompleteableItem) => void = ({
    payload,
  }) => addCompanyManagerToCompany(dispatch, companyId, payload)

  const addOtherRole: (item: AutocompleteableItem, selectedFolder?: number[]) =>
    void = ({
      payload,
    }) => {
      addOtherRoles(dispatch, projectId, templateDocumentId, selectedFolder, payload, url)
    }

  const folderSelectionHandler: any = useCallback((selectedList: any) => {
    setSelectedFolder(selectedList)
  }, [])

  const comapnyManagers: any = (useCompanyManagers() || []);
  let id;
  // if(roleType == 'Company Manager')
  //   id = 'company_managers'
  if (roleType == 'Project Manager')
    id = 'project_managers'
  else if (roleType == 'Super/Foreman')
    id = 'super_foremans'
  else if (roleType == 'Sub-contractor/Foreman')
    id = 'sub_contractors'
  else if (roleType == 'Project Coordinator')
    id = 'project_coordinators'
  const otherRoles = useOtherRoles(id) || [];

  return (
    isOtherRole ?
      <AddUserDropdown
        addUser={addOtherRole}
        excludedMembers={otherRoles}
        users={otherRoles}
        userType={roleType}
        projectId={projectId}
        templateDocumentId={templateDocumentId}
        selectedFolder={selectedFolder || []}
        onSelectionHandler={folderSelectionHandler}
      />
      :
      <AddUserDropdown
        addUser={addCompanyManager}
        excludedMembers={comapnyManagers}
        users={comapnyManagers}
        userType="Company Manager"
        projectId={projectId}
        templateDocumentId={templateDocumentId}
      />
  )
}